import { Injectable } from '@angular/core';
import { BaseRestService, ServiceProperties } from '@beneficity/shared/types';
import { Observable } from 'rxjs';
import { ExpLayerHttpClientService } from '@beneficity/shared/util';
import { MemberData } from '@beneficity/authentication/types';

@Injectable({
  providedIn: 'root',
})
export class EligibilityBrandService implements BaseRestService {
  serviceProperties: ServiceProperties;
  private readonly BRAND_UBK = 'brandubk';
  constructor(private readonly http: ExpLayerHttpClientService) {
    this.serviceProperties = {
      url: '/digital/v3/members/eligibility/brand',
    };
  }

  fetch(
    token: string,
    defaultOverrideValues?: Record<string, string>
  ): Observable<MemberData[]> {
    const params: Record<string, string> = {};
    const headers: { [key: string]: string } = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    if (Boolean(defaultOverrideValues)) {
      for (const k of Object.keys(defaultOverrideValues)) {
        if (
          k.toLowerCase() === this.BRAND_UBK &&
          Boolean(defaultOverrideValues[k])
        ) {
          params.ubk = defaultOverrideValues[k];
        }
      }
    }
    if (Object.keys(params).length <= 0) {
      params.currentBrand = 'true';
    }

    return this.http.get(this.serviceProperties, params, headers);
  }
}
